import { Brand } from '@kaizen/brand';
import React from 'react';

type Props = {
  styles?: string;
  reversed?: boolean;
};

export const CaLogo = (props: Props) => {
  return (
    <div {...(props.styles && { className: props.styles })}>
      <Brand
        variant="logo-horizontal"
        alt="Culture Amp"
        reversed={props.reversed ? true : undefined}
      />
    </div>
  );
};
